import { Delete } from '@mui/icons-material';
import {
  Checkbox,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { ILegalClient } from '../../../Interfaces/ILegalClient';
import { ILegalTransactionRelationship } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { useLegalClientStore } from '../../public/Dialog/generic/legalClientStore';
import { removeLegalClientFromRelationships } from '../../public/Dialog/generic/utilities';
import { EmailInput } from '../fields/Email/EmailInput';

export type ILegalClientSummaryTableProps = {
  relationshipArray: ILegalTransactionRelationship[];
  setRelationshipArray: React.Dispatch<
    React.SetStateAction<ILegalTransactionRelationship[]>
  >;
};

export function LegalClientSummaryTable({
  relationshipArray,
  setRelationshipArray,
}: ILegalClientSummaryTableProps) {
  const [legalClientArray, putLegalClient, removeLegalClient] =
    useLegalClientStore(state => [
      state.legalClientArray,
      state.putLegalClient,
      state.removeLegalClient,
    ]);

  const handleRemove = (currentLegalClient: ILegalClient) => {
    removeLegalClient(currentLegalClient.idLegalClient);
    setRelationshipArray(
      removeLegalClientFromRelationships(
        relationshipArray,
        currentLegalClient.idLegalClient
      )
    );
  };

  return (
    <Table>
      <TableHead>
        <TableCell width={10}></TableCell>
        <TableCell>Name</TableCell>
        <TableCell>E-Mail</TableCell>
        <TableCell width={10}></TableCell>
      </TableHead>
      <TableBody>
        {legalClientArray.map(legalClient => (
          <TableRow key={`client-${legalClient.idLegalClient}`}>
            <TableCell>
              <Checkbox
                checked={legalClient.data.addToLegalTransaction}
                onChange={() => {
                  putLegalClient({
                    idLegalClient: legalClient.idLegalClient,
                    data: {
                      ...legalClient.data,
                      addToLegalTransaction:
                        !legalClient.data.addToLegalTransaction,
                    },
                  });
                }}
                inputProps={{ 'aria-label': 'controlled' }}
              />
            </TableCell>
            <TableCell>
              {legalClient.FirstName} {legalClient.LastName}
            </TableCell>
            <TableCell>
              <EmailInput
                value={legalClient.Email}
                onChange={value =>
                  putLegalClient({
                    idLegalClient: legalClient.idLegalClient,
                    Email: value,
                  })
                }
                required={!!legalClient.data.addToLegalTransaction}
              />
            </TableCell>
            <TableCell>
              {legalClient.idRelationshipRole === 0 && (
                <IconButton onClick={() => handleRemove(legalClient)}>
                  <Delete />
                </IconButton>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
